import { Snackbar, Alert } from "@mui/material";
import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { getMessaging, onMessage, getToken }  from "firebase/messaging"; 
import {app, auth} from "../../../scripts/app";
const ENV_VAPID_KEY = process.env.REACT_APP_VAPID_KEY

const SnackbarAlert = () => {
    const [currentUser, setUser] = useState(null);

    useEffect(() => {
        onAuthStateChanged(auth, user => setUser(user));
    }, []);

    useEffect(() => {
        if (!currentUser) return;
        updateMessagingToken(currentUser,
            () => alert.show('Notifications not permitted', 'warning'),
            () => alert.show('Notifications not supported', 'warning'));
    }, [currentUser]);

    const alert = useAlert();

    return (
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={6000}
            open={alert.isOpen}
            onClose={alert.handleClose}>
            <Alert severity={alert.severity}>{alert.message}</Alert>
        </Snackbar>
    );
};

const useAlert = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('');

    const show = (message, severity) => {
        setIsOpen(true);
        setMessage(message);
        setSeverity(severity);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return { isOpen, message, severity, show, handleClose };
};

const getTeamUserRefs = async (user) => {
    const snaps = await getTeamUserSnaps(user);
    return snaps.map(doc => doc.ref);
};

const getTeamUserSnaps = async (user) => {
    const currentUser = await getUserData(user);
    if (currentUser.id == null) return [];
    const usersSnap = await db.collectionGroup('users').where('id', '==', currentUser.id).get();
    return usersSnap.docs.filter(doc => doc.ref.path.indexOf('teams') != -1);
};

const getUserData = async (user) => {
    const snap = await getSnap(user);
    if (snap == null) return null;
    return snap.data() != null ? snap.data() : { name: user.email, email: user.email };
};

const getSnap = async (user) => {
    // Set to account user with same email
    const usersQuery = db.collection('users').where('email', '==', user.email);
    const usersSnap = await usersQuery.get();
    return usersSnap.docs[0];
};

const updateMessagingToken = (currentUser, onDenied, onUnsupported) => {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: ENV_VAPID_KEY }).then(async currentToken => {
        if (currentToken) {
            const teamUserRefs = await getTeamUserRefs(currentUser);
            for (const ref of teamUserRefs) ref.update({ messagingToken: currentToken });
        } else {
            requestNotificationPermission(currentUser, onDenied, onUnsupported);
        }
    }).catch(err => {
        requestNotificationPermission(currentUser, onDenied, onUnsupported);
    });
    onMessage(messaging, payload => {
        const notification = new Notification(payload.notification.title, {
            body: payload.notification.body,
            icon: '/icons/icon-192x192.png',
            tag: payload.data.tag
        });
        notification.onclick = () => {
            location.href = payload.notification.click_action;
        };
    });
};

const requestNotificationPermission = async (currentUser, onDenied, onUnsupported) => {
    if (!("Notification" in window)) {
        console.log("Notifications not supported");
        if (onUnsupported) onUnsupported();
    } else {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            updateMessagingToken(currentUser, onDenied, onUnsupported);
        } else {
            console.log('Notification permission denied');
            if (onDenied) onDenied();
        }
    }
}
export default SnackbarAlert